import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT_LAYOUT_TYPE, GET_LAYOUT_TYPE } from "../../../queries/layout_type";

const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT_LAYOUT_TYPE}
      update={(cache, { data: { updateLayoutTypes } }) => {
        const { layoutTypesAll } = cache.readQuery({ query: GET_LAYOUT_TYPE });
        cache.writeQuery({
          query: GET_LAYOUT_TYPE,
          data: { layoutType: layoutTypesAll }
        });
      }}
      >
      {updateLayoutTypes => (
        <Form query_f = {updateLayoutTypes} {...props} />
      )}
    </Mutation>
  );
};

export default Update;